import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "security"
    }}>{`Security`}</h1>
    <p>{`This section contains information that Adobe Commerce and Magento Open Source developers can use to improve the security of the components that they build.`}</p>
    <p>{`Topics in this section include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "authorization.md"
        }}><strong parentName="a">{`Authorization`}</strong></a>{`—Control access to pages using different authorization strategies.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "brute-force.md"
        }}><strong parentName="a">{`Brute force attacks`}</strong></a>{`—Identify and protect component functionality vulnerable to brute force attacks.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "content-security-policies.md"
        }}><strong parentName="a">{`Content security policies`}</strong></a>{`—Mitigate against cross-site scripting and related attacks with content security policies.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "cross-site-request-forgery.md"
        }}><strong parentName="a">{`Cross-site request forgery`}</strong></a>{`—Leverage built-in cross-site request forgery (CSRF) protection when developing components.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "cross-site-scripting.md"
        }}><strong parentName="a">{`Cross-site scripting`}</strong></a>{`—Implement cross-site-scripting (XSS) prevention strategies when developing components.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "denial-of-service-attacks.md"
        }}><strong parentName="a">{`Denial of service (DoS) attacks`}</strong></a>{`—Identify and protect component functionality vulnerable to denial of service attacks.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "file-uploads.md"
        }}><strong parentName="a">{`File uploads`}</strong></a>{`—Use out-of-the-box abstraction to safely work with user-uploaded files.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "mass-assignment.md"
        }}><strong parentName="a">{`Mass assignment`}</strong></a>{`—Prevent components from allowing bad actors to override user-editable properties with arbitrary values in HTTP requests.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "non-secure-functions.md"
        }}><strong parentName="a">{`Non-secure functions`}</strong></a>{`—Avoid using PHP functions in components that are known to be vulnerable and exploitable.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sensitive-information.md"
        }}><strong parentName="a">{`Sensitive information`}</strong></a>{`—Prevent components from exposing sensitive information, like customer passwords, addresses, and dates of birth`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "server-side-request-forgery.md"
        }}><strong parentName="a">{`Server-side request forgery`}</strong></a>{`—Follow these strategies to prevent server-site request forgery (CSRF) vulnerabilities in components.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "subresource-integrity.md"
        }}><strong parentName="a">{`Subresource integrity`}</strong></a>{`— Security feature that enables browsers to verify the resources that they fetch.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      